<ol>
  @for (message of messages; track message) {
    <li
      [class]="{received: message.messageType === 'Received', sent: message.messageType === 'Sent'}">
      <app-message
        [companionName]="companionName"
        [messageType]="message.messageType.toLowerCase()"
        [timestamp]="message.timestamp"
        >{{ message.text }}
      </app-message>
    </li>
  }
</ol>
